"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const guard_1 = require("../guard");
const shared_1 = require("../shared");
const OtaGroup = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device.OtaGroup.Spec';
const GroupListResponse = openapi_1.Response.Success(OtaGroup.OtaGroupList).annotations({
    description: 'All OTA groups',
});
const GroupItemResponse = openapi_1.Response.Success(OtaGroup.OtaGroupItem).annotations({
    description: 'An OTA group',
});
const DevicesNotFound = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.DevicesNotFound`, 'INVALID_REQUEST', 'Devices Not Found', 'One or more serialNumbers do not match an existing device. Carries no express-validator field errors.', { inputValidation: effect_1.Schema.Literal('DEVICES_NOT_FOUND') });
const listOtaGroups = platform_1.HttpApiEndpoint.get('listOtaGroups') `/ota/group/list`
    .addSuccess(GroupListResponse)
    .annotate(platform_1.OpenApi.Title, 'List OTA Groups')
    .annotate(platform_1.OpenApi.Description, 'Returns every OTA group. No pagination.')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const getOtaGroup = platform_1.HttpApiEndpoint.get('getOtaGroup') `/ota/group`
    .setUrlParams(shared_1.IdQuery)
    .addSuccess(GroupItemResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Get OTA Group')
    .pipe(guard_1.withReadGuard, openapi_1.Error.withV1StandardErrors);
const createOtaGroup = platform_1.HttpApiEndpoint.post('createOtaGroup') `/ota/group`
    .setPayload(OtaGroup.CreateOtaGroupPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1Conflict)
    .addError(DevicesNotFound)
    .annotate(platform_1.OpenApi.Title, 'Create OTA Group')
    .annotate(platform_1.OpenApi.Description, '409 when the name is already taken. 422 DEVICES_NOT_FOUND when a serial number does not match an existing device. model is derived from the first device in the list.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const updateOtaGroup = platform_1.HttpApiEndpoint.put('updateOtaGroup') `/ota/group`
    .setPayload(OtaGroup.UpdateOtaGroupPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .addError(DevicesNotFound)
    .annotate(platform_1.OpenApi.Title, 'Replace OTA Group')
    .annotate(platform_1.OpenApi.Description, 'Full replacement. Name uniqueness is not re-checked on update, and createdBy is overwritten with the caller.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
const deleteOtaGroup = platform_1.HttpApiEndpoint.del('deleteOtaGroup') `/ota/group`
    .setUrlParams(effect_1.Schema.Struct({ id: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }) }))
    .setPayload(OtaGroup.DeleteOtaGroupPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Delete OTA Group')
    .annotate(platform_1.OpenApi.Description, 'id may be supplied via query or body (at least one is required); the query id wins when both are present.')
    .pipe(guard_1.withWriteGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.device.ota-group')
    .add(listOtaGroups)
    .add(getOtaGroup)
    .add(createOtaGroup)
    .add(updateOtaGroup)
    .add(deleteOtaGroup)
    .prefix('/admin/device')
    .annotate(platform_1.OpenApi.Title, 'Device OTA Groups')
    .annotate(platform_1.OpenApi.Description, 'Admin OTA device-group endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map